import type { Mode } from '../types/xbees';

/** Loads React/MUI only for modes that show UI; the background instance never pays for them. */
export async function startUILazy(mode: Mode | 'callback'): Promise<void> {
  const { startUI } = await import('./startUI');
  startUI(mode);
}
